import { Pipe } from '@angular/core';
var DiffPipe = (function () {
    function DiffPipe() {
    }
    DiffPipe.prototype.transform = function (input) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!Array.isArray(input)) {
            return input;
        }
        // tslint:disable-next-line no-bitwise
        return args.reduce(function (d, c) { return d.filter(function (e) { return !~c.indexOf(e); }); }, input);
    };
    DiffPipe.decorators = [
        { type: Pipe, args: [{ name: 'diff' },] },
    ];
    /** @nocollapse */
    DiffPipe.ctorParameters = function () { return []; };
    return DiffPipe;
}());
export { DiffPipe };
//# sourceMappingURL=diff.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/diff.js
// module id = 220
// module chunks = 4